module.exports = __webpack_public_path__ + "assets/img/4883557990edb7cb2a727a8d5024feca.png";